import * as Yup from "yup";

export const validationBasicInfo = Yup.object().shape({
  first_name: Yup.string()
    .min(2, "First name must be at least 2 characters")
    .max(55, "First name must be at most 55 characters")
    .required("Enter First Name"),
  middle_name: Yup.string()
    .min(2, "Middle name must be at least 2 characters")
    .max(55, "Middle name must be at most 55 characters")
    .notRequired(),
  last_name: Yup.string()
    .min(2, "Last name must be at least 2 characters")
    .max(55, "Last name must be at most 55 characters")
    .required("Please enter Last Name"),
  father_name: Yup.string()
    .min(2, "Father name must be at least 2 characters")
    .max(55, "Father name must be at most 55 characters")
    .required("Enter Father Name"),
  phone: Yup.string().required("Enter Your Phone No."),
  email: Yup.string().required("Enter Your E-mail address"),
  dobn: Yup.string().required("Please enter DOB (BS)"),
  name_nep: Yup.string().required("Please enter Nepali Name"),

  gender: Yup.string().required("Please enter Gender"),
  marital_status: Yup.string().required("Please enter Marital Status"),
  phone: Yup.string()
    .matches(/^\d{10}$/, "Phone number must be a 10-digit number")
    .required("Please enter a Phone Number"),

  nationality: Yup.string()
    .min(2, "Nationality must be at least 2 characters")
    .max(30, "Nationality must be at most 30 characters")
    .required("Please enter Nationality"),
  caste: Yup.string().required("Please select Ethnicity"),
  religion: Yup.string().required("Please select Religion"),
  date_of_joining: Yup.string().required("Please enter joining date."),
  lang: Yup.string().required("Please enter language"),
  teaching: Yup.string().required("Please select Teacing / NoTeaching"),
  no_of_teach_hr: Yup.string().required("Please Enter teaching hours"),
  subj: Yup.string().required("Please Enter teaching subject"),
  faculty: Yup.string().required("Please select teaching faculty"),
  staff_type: Yup.string().required("Please Select Staff Type"),
  part_full: Yup.string().required("Please Select Full/Part Time Staff"),

});

export const validationAddressInfo = Yup.object().shape({
  province: Yup.string().required("Province is required"),
  district: Yup.string().required("District is required"),
  municipality: Yup.string().required("Municipality is required"),
  wardno: Yup.number()
    .typeError("Ward number must be a number")
    .required("Ward number is required"),
  tole: Yup.string().nullable(),
  house_no: Yup.string().nullable(),
  add_nep: Yup.string().required("Address is required"),

  // For Current Address
  samePermanent: Yup.boolean(),

  // Conditional fields: only required when samePermanent is false
  t_province: Yup.string().when("samePermanent", {
    is: false,
    then: (schema) => schema.required("Province is required"),
  }),
  t_district: Yup.string().when("samePermanent", {
    is: false,
    then: (schema) => schema.required("District is required"),
  }),
  t_municipality: Yup.string().when("samePermanent", {
    is: false,
    then: (schema) => schema.required("Municipality is required"),
  }),
  t_wardno: Yup.number().when("samePermanent", {
    is: false,
    then: (schema) =>
      schema
        .typeError("Ward number must be a number")
        .required("Ward number is required"),
  }),

  t_tole: Yup.string().nullable(),
  t_house_no: Yup.string().nullable(),
});

export const validationAcademicsInfo = Yup.object({
  name_of_insti: Yup.string().required("Please Enter name of institution"),
  ac_level: Yup.string().required("Please select Academics Level"),
  ac_faculty: Yup.string().required("Enter academics Faculty"),
  ac_program: Yup.string().required("Enter academics program"),
});

export const validationBankInfo = Yup.object({
  bank_holder_name: Yup.string().required("Please Enter name of institution"),
  account_number: Yup.string().required("Please enter account number"),
  bank_name: Yup.string().required("Enter Bank Name"),
  branch_name: Yup.string().required("Enter Branch Name"),
  pan_no: Yup.string().required("Enter Pan No."),
});

export const validationSalaryInfo = Yup.object({
    initail_salary: Yup.number()
    .typeError("Initial Salary must be a number")
    .required("Enter Initial Salary"),
  grade_count: Yup.number().typeError("Grade count must be a number").required("Enter Grade Count"),
  grade_amt: Yup.number().typeError("Grade amount must be a number").required("Enter Grade Amount"),
  allowance: Yup.number().typeError("Allowance must be a number").required("Enter Allowance"),
  extra_period: Yup.number().typeError("Extra Period must be a number").required("Enter Extra Period"),
  post_allowance: Yup.number().typeError("Post Allowance must be a number").required("Enter Post Allowance"),
  irre_period: Yup.number().typeError("Irregular period must be a number").required("Enter Irregular period"),
  sem_period: Yup.number().typeError("Semester period must be a number").required("Enter Semester period"),
  hit_kosh: Yup.number().typeError("Hit Kosh must be a number").required("Enter Hit Kosh"),
  tax_amt: Yup.number().typeError("Tax amount must be a number").required("Enter Tax amount."),
  pf_amount: Yup.number().typeError("PF amount must be a number").required("Enter PF amount."),
  pf_thap_perc: Yup.number().typeError("PF Thap Percentage must be a number").required("Enter PF Thap Percentage"),
  ss_tax: Yup.number().typeError("SS Tax must be a number").required("Enter SS Tax"),
  insurance: Yup.number().typeError("Insurance must be a number").required("Enter Insurance Amount"),
  ss_found: Yup.number().typeError("SS found must be a number").required("Enter SS found Amount"),
});
